export default {"src":"/_next/static/media/caret-down.29442e0d.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};